"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.triggerOnPage = triggerOnPage;
const openPopUp_1 = require("../openPopUp");
function triggerOnPage(url, options) {
    try {
        const popup = openPopUp_1.Popup.getInstance(options.fullscreenWindow);
        popup.openWindow(url, options);
        return {
            getOpenedWindow: popup.getOpenedWindow,
            updateUrl: popup.updateWindowURL,
        };
    }
    catch (error) {
        throw error;
    }
}
